module.exports = __webpack_public_path__ + "img/calendar-clock.99725c43.svg";